// Content Scroller
const scrollBody = document.querySelector('.market-body');
const target = document.querySelector('.market-body__scroll');
const title = document.querySelector('.market-body__title');
const scrollLinks = document.querySelectorAll('.scroll-link');

const scrollItems = document.querySelectorAll('.market-body__scroll--item');
const scrollItemJump = 100 / scrollItems.length;

const targetMax = 0;
const targetMin = -90;
let targetScroll = targetMax;
let titleScroll = targetScroll;
let touchStartX;
let touchStartY;

const updateTargetPosition = () => {
  if (target) {
    target.style.transform = `translateX(${targetScroll}%)`;
  }
  if (title) {
    title.style.transform = `translateX(${titleScroll}%)`;
  }
}

const updateActiveLink = () => {
  scrollItems.forEach((item) => {
    const bound = item.getBoundingClientRect();
    if (bound.left > 0 && bound.left < screen.width * 0.4) {
      document.querySelector('.scroll-link.active').classList.remove('active');
      document.querySelector('[href="#' + item.getAttribute('id') + '"]').classList.add('active');
    }
  });
}

const handleScroll = (e) => {
  let x = Math.abs(e.deltaY / 100);
  targetScroll = e.deltaY > 0 ? targetScroll - x : targetScroll + x;
  titleScroll = targetScroll / 2;

  if (targetScroll > targetMax) {
    targetScroll = targetMax;
    titleScroll = 0;
  } else if (targetScroll < targetMin) {
    targetScroll = targetMin;
    titleScroll = targetScroll / 2;
  } else {
    e.preventDefault();
  }

  updateTargetPosition();
};

const handleScrollLink = (e) => {
  e.preventDefault();
  document.querySelector('.scroll-link.active').classList.remove('active');
  e.target.classList.add('active');
  targetScroll = ([...scrollLinks].indexOf(e.target) * scrollItemJump) * -1;
  titleScroll = targetScroll / 2;

  updateTargetPosition();
};

const handleHorizontalTouchScroll = (e) => {
  const touchCurrentX = e.touches[0].clientX;
  const touchCurrentY = e.touches[0].clientY;
  const deltaX = touchStartX - touchCurrentX;
  const deltaY = touchStartY - touchCurrentY;
  touchStartX = touchCurrentX;
  touchStartY = touchCurrentY;

  // calculating the angle in radians
  const angle = Math.abs(Math.atan2(deltaY, deltaX));

  if (angle < 45 || angle > 135) {
    // 0.02 - adjustable value to adjust the touch scrolling speed/smoothness
    targetScroll -= deltaX * 0.02;
    titleScroll = targetScroll / 2;

    if (targetScroll > targetMax) {
      targetScroll = targetMax;
      titleScroll = 0;
    } else if (targetScroll < targetMin) {
      targetScroll = targetMin;
      titleScroll = targetScroll / 2;
    }

    updateActiveLink();
    updateTargetPosition();
  }
}

// eslint-disable-next-line import/prefer-default-export
export const eventListeners = () => {
  if (scrollBody != null) {
    scrollBody.addEventListener('wheel', handleScroll);

    scrollBody.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    });

    // to update the active link after completing a quick long swipe or mouse scroll
    scrollBody.addEventListener('transitionend', updateActiveLink);

    scrollBody.addEventListener('touchmove', handleHorizontalTouchScroll);

    scrollLinks.forEach((item, index) => {
      item.linkIndex = index;
      item.addEventListener('click', handleScrollLink);
    });
  }
};



// WEBPACK FOOTER //
// ./src/templates/components/market-header/market-header.js